import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
	selector: 'experience-ai-advisor-tab-1-part',
	standalone: true,
	templateUrl: './experience-ai-advisor-tab-1.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: [`./experience-ai-advisor-tab-1.part.scss`],
})
export class ExperienceAIAdvisorTab1Part {
}
